import React from 'react';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import HeadquarterSalesGoalContainer from './HeadquarterSalesGoalContainer';

const SalesGoalContainer = () => {
  return (
    <>
      <BreadcrumbsContainer
        title="세금계산서 관리/목표 및 실적관리/목표 및 실적"
        icon="goal"
      />
      <DetailTemplate title="본부별 목표 및 실적">
        <HeadquarterSalesGoalContainer />
      </DetailTemplate>
    </>
  );
};

export default SalesGoalContainer;
